import JsCookie from "js-cookie";

import {
  OKTA_AUTH_STARTED,
  OKTA_AUTH_SUCCESS,
  OKTA_AUTH_FAILURE,
  UPDATE_DISCLAIMER_STATUS,
} from "../constants/auth.constant";
import { COOKIE_LANG_ID, COOKIE_REGION_ID, EN_USER_INFO, GLOBAL_REGION_ID } from "../constants/cookie.constant";

import { ajaxInstance } from "../axiosRetryAgent";
import { API_URL } from "../constants";
import * as isVersion from "react-device-detect";

export const loginAuth = ({ idToken, clientId, version }) => {
  return (dispatch) => {
    const email = JSON.parse(localStorage.getItem("okta-token-storage")).idToken.claims.email;
    let currentDate = new Date();
    if (isVersion.isMobile) {
      version = 1;
      console.log("This is mobile " + version);
    } else if (isVersion.isDesktop) {
      version = 0;
      console.log("This is desktop " + version);
    }
    
    dispatch(loginAuthStarted());
    
    const instance = ajaxInstance();
    instance
      .get(`${API_URL}home/GetAllDefaultSettingsEN?version=` + version, {
        params: {
          email,
        },
      })
      .then((res) => {
        for (const index in res.data.region_Global[0].children) {
          res.data.region_Global[0].children[index]["isRegion"] = true;
        }
        for (const index in res.data.region_Global) {
          const { title, regionId } = res.data.region_Global[index];
          if (title === "Global") {
            localStorage.setItem(GLOBAL_REGION_ID, regionId);
            break;
          }
        }
        localStorage.setItem(EN_USER_INFO, JSON.stringify(res.data));
        if (!JsCookie.get(COOKIE_REGION_ID)) {
          console.log("Default region cookie is missing >><>");
          JsCookie.set(COOKIE_REGION_ID, res.data.defaultregionrd);
        }
        if(!JsCookie.get(COOKIE_LANG_ID)) {
          console.log("Defaultl language cookie is missing >><>");
          JsCookie.set(COOKIE_LANG_ID, res.data.defaultlanguageid);
        }
      })
      .catch((err) => {
        console.log("English Setting Error:::", err);
      });

    instance
      .get(`${API_URL}home/GetAllDefaultSettings?version=` + version, {
        params: {
          email,
        },
      })
      .then((res) => {
        localStorage.setItem("metadata", JSON.stringify(res.data));
        //localStorage.setItem('xsrfToken', JSON.stringify(res.headers['xsrf-token']));
        dispatch(loginAuthSuccess(res.data));
      })
      .catch((err) => {
        dispatch(loginAuthFailure(err.message));
      });
  };
};

const loginAuthSuccess = (loggedUserInfo) => ({
  type: OKTA_AUTH_SUCCESS,
  payload: {
    ...loggedUserInfo,
  },
});

const loginAuthStarted = () => ({
  type: OKTA_AUTH_STARTED,
});

const loginAuthFailure = (error) => ({
  type: OKTA_AUTH_FAILURE,
  payload: {
    error,
  },
});

const updateFirstTimeUser = (isLoading, isAccepted) => ({
  type: UPDATE_DISCLAIMER_STATUS,
  payload: {
    isLoading,
    isAccepted,
  },
});

export const updateTermsCondition = (userId) => {
  return (dispatch) => {
    dispatch(updateFirstTimeUser(true, false));
    const instance = ajaxInstance();
    instance
      .post(`${API_URL}home/AcceptTerms?userId=${userId}&acceptance=true`)
      .then(() => {
        dispatch(updateFirstTimeUser(false, true));
      })
      .catch(() => {
        dispatch(updateFirstTimeUser(false, false));
      });
  };
};
